import * as i1 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, Directive, HostBinding, NgModule } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subject, merge, fromEvent } from 'rxjs';
import { filter, tap, takeUntil } from 'rxjs/operators';
import { isValidOpenKeyCode } from '@mercadona/components/common';
import { trigger, transition, style, animate } from '@angular/animations';

const defaultPosition = 'top';

const popoverAnimation = trigger('popover', [
    transition(':enter', [style({ opacity: 0 }), animate('300ms ease-out', style({ opacity: 1 }))]),
    transition(':leave', [style({ opacity: 1 }), animate('300ms ease-out', style({ opacity: 0 }))])
]);

class MPopoverComponent {
    constructor(_changeDetectorRef, _elementRef, _configurableFocusTrapFactory) {
        this._changeDetectorRef = _changeDetectorRef;
        this._elementRef = _elementRef;
        this._configurableFocusTrapFactory = _configurableFocusTrapFactory;
    }
    ngAfterViewInit() {
        this._focusTrap = this._configurableFocusTrapFactory.create(this._elementRef.nativeElement);
        this._focusTrap.focusInitialElementWhenReady();
    }
    ngOnDestroy() {
        this._focusTrap?.destroy();
    }
}
MPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: i1.ConfigurableFocusTrapFactory }], target: i0.ɵɵFactoryTarget.Component });
MPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: MPopoverComponent, selector: "m-popover", inputs: { content: "content", popoverElementRef: "popoverElementRef" }, ngImport: i0, template: "<div #popover @popover [class]=\"'m-popover'\">\n  <ng-container *ngTemplateOutlet=\"$any(content)\"></ng-container>\n</div>\n", styles: [":host{display:block;position:relative}:host .m-popover{position:relative}::ng-deep .m-popover-panel{padding:1rem;border-radius:.125rem;filter:drop-shadow(0 2px 5px rgba(0,0,0,.3));min-width:min-content;max-height:max-content}@media (max-width: 120em){::ng-deep .m-popover-panel{max-width:37.313rem}}@media (max-width: 85em){::ng-deep .m-popover-panel{max-width:25.5rem}}@media (max-width: 64em){::ng-deep .m-popover-panel{max-width:100%}}@media (max-width: 48em){::ng-deep .m-popover-panel{max-width:100%}}::ng-deep .m-popover-panel.m-popover-position-top:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;bottom:-.5rem;border-top:.5rem solid var(--popover-background-color);left:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-topLeft:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;bottom:-.5rem;border-top:.5rem solid var(--popover-background-color);right:.5rem}::ng-deep .m-popover-panel.m-popover-position-topRight:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;bottom:-.5rem;border-top:.5rem solid var(--popover-background-color);left:.5rem}::ng-deep .m-popover-panel.m-popover-position-bottom:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;top:-.5rem;border-bottom:.5rem solid var(--popover-background-color);left:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-bottomLeft:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;top:-.5rem;border-bottom:.5rem solid var(--popover-background-color);right:.5rem}::ng-deep .m-popover-panel.m-popover-position-bottomRight:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;top:-.5rem;border-bottom:.5rem solid var(--popover-background-color);left:.5rem}::ng-deep .m-popover-panel.m-popover-position-left:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;right:-.5rem;border-left:.5rem solid var(--popover-background-color);top:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-leftTop:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;right:-.5rem;border-left:.5rem solid var(--popover-background-color);bottom:.25rem}::ng-deep .m-popover-panel.m-popover-position-leftBottom:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;right:-.5rem;border-left:.5rem solid var(--popover-background-color);top:.25rem}::ng-deep .m-popover-panel.m-popover-position-right:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;left:-.5rem;border-right:.5rem solid var(--popover-background-color);top:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-rightTop:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;left:-.5rem;border-right:.5rem solid var(--popover-background-color);bottom:.25rem}::ng-deep .m-popover-panel.m-popover-position-rightBottom:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;left:-.5rem;border-right:.5rem solid var(--popover-background-color);top:.25rem}::ng-deep .m-popover-style-default{background-color:var(--popoverDefaultBackgroundColor);--popover-background-color: var(--popoverDefaultBackgroundColor)}::ng-deep .m-popover-style-alternative{background-color:var(--popoverAlternativeBackgroundColor);--popover-background-color: var(--popoverAlternativeBackgroundColor)}::ng-deep .m-popover-style-custom{background-color:var(--popover-background-color);--background-color: background-color}\n"], dependencies: [{ kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], animations: [popoverAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'm-popover', changeDetection: ChangeDetectionStrategy.OnPush, animations: [popoverAnimation], template: "<div #popover @popover [class]=\"'m-popover'\">\n  <ng-container *ngTemplateOutlet=\"$any(content)\"></ng-container>\n</div>\n", styles: [":host{display:block;position:relative}:host .m-popover{position:relative}::ng-deep .m-popover-panel{padding:1rem;border-radius:.125rem;filter:drop-shadow(0 2px 5px rgba(0,0,0,.3));min-width:min-content;max-height:max-content}@media (max-width: 120em){::ng-deep .m-popover-panel{max-width:37.313rem}}@media (max-width: 85em){::ng-deep .m-popover-panel{max-width:25.5rem}}@media (max-width: 64em){::ng-deep .m-popover-panel{max-width:100%}}@media (max-width: 48em){::ng-deep .m-popover-panel{max-width:100%}}::ng-deep .m-popover-panel.m-popover-position-top:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;bottom:-.5rem;border-top:.5rem solid var(--popover-background-color);left:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-topLeft:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;bottom:-.5rem;border-top:.5rem solid var(--popover-background-color);right:.5rem}::ng-deep .m-popover-panel.m-popover-position-topRight:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;bottom:-.5rem;border-top:.5rem solid var(--popover-background-color);left:.5rem}::ng-deep .m-popover-panel.m-popover-position-bottom:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;top:-.5rem;border-bottom:.5rem solid var(--popover-background-color);left:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-bottomLeft:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;top:-.5rem;border-bottom:.5rem solid var(--popover-background-color);right:.5rem}::ng-deep .m-popover-panel.m-popover-position-bottomRight:after{height:.5rem;width:1rem;position:absolute;content:\"\";border-left:.5rem solid transparent;border-right:.5rem solid transparent;top:-.5rem;border-bottom:.5rem solid var(--popover-background-color);left:.5rem}::ng-deep .m-popover-panel.m-popover-position-left:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;right:-.5rem;border-left:.5rem solid var(--popover-background-color);top:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-leftTop:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;right:-.5rem;border-left:.5rem solid var(--popover-background-color);bottom:.25rem}::ng-deep .m-popover-panel.m-popover-position-leftBottom:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;right:-.5rem;border-left:.5rem solid var(--popover-background-color);top:.25rem}::ng-deep .m-popover-panel.m-popover-position-right:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;left:-.5rem;border-right:.5rem solid var(--popover-background-color);top:calc(50% - .5rem)}::ng-deep .m-popover-panel.m-popover-position-rightTop:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;left:-.5rem;border-right:.5rem solid var(--popover-background-color);bottom:.25rem}::ng-deep .m-popover-panel.m-popover-position-rightBottom:after{height:.5rem;width:.5rem;position:absolute;content:\"\";border-top:.5rem solid transparent;border-bottom:.5rem solid transparent;left:-.5rem;border-right:.5rem solid var(--popover-background-color);top:.25rem}::ng-deep .m-popover-style-default{background-color:var(--popoverDefaultBackgroundColor);--popover-background-color: var(--popoverDefaultBackgroundColor)}::ng-deep .m-popover-style-alternative{background-color:var(--popoverAlternativeBackgroundColor);--popover-background-color: var(--popoverAlternativeBackgroundColor)}::ng-deep .m-popover-style-custom{background-color:var(--popover-background-color);--background-color: background-color}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i1.ConfigurableFocusTrapFactory }]; }, propDecorators: { content: [{
                type: Input
            }], popoverElementRef: [{
                type: Input
            }] } });

class MPopoverDirective {
    /**
     * Popover constructor
     *
     * @param _overlay CDK _overlay to render the popover
     * @param _overlayPositionBuilder CDK helper builder for positioning
     * @param _elementRef Reference for native element
     * @param _ngZone
     */
    constructor(_overlay, _overlayPositionBuilder, _elementRef) {
        this._overlay = _overlay;
        this._overlayPositionBuilder = _overlayPositionBuilder;
        this._elementRef = _elementRef;
        this._customPanelClass = 'default';
        this.class = 'm-popover';
        /**
         * A helper variable to manage the visibility state
         */
        this.isPopoverVisible = false;
        this._defaultConnectedPosition = [
            {
                originX: 'center',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'bottom',
                offsetY: -16
            }
        ];
        this._popoverPosition = defaultPosition;
        this._disabled = false;
        this._destroy$ = new Subject();
    }
    get hideTriangle() {
        return this._hideTriangle;
    }
    set hideTriangle(value) {
        this._hideTriangle = coerceBooleanProperty(value);
    }
    /**
     * Defines custom panel class to customize panel styles
     */
    get customPanelClass() {
        return this._customPanelClass;
    }
    set customPanelClass(value) {
        if (this._customPanelClass !== value) {
            if (this._overlayRef) {
                this.updateClases(value);
            }
            this._customPanelClass = value;
        }
    }
    /**
     * Content popover. It is possible to set a `TemplateRef<MSafeAny>`
     *
     */
    get content() {
        return this._content;
    }
    set content(value) {
        this._content = value;
        this.setPopoverContent();
    }
    /**
     * Defines the position for the popover over the element with the directive.
     * There are different positions predefined, wich have specified
     * `overlayX`, `overlayY`, `originX`, `originY`, `offsetX` and `offsetY`.
     *
     * If you want a custom origin, _overlay and offset, you can pass `custom`
     * as `popoverPosition` and the custom object with these properties in `popoverCustomPositionConfig`.
     */
    get popoverPosition() {
        return this._popoverPosition;
    }
    set popoverPosition(value) {
        if (value !== this._popoverPosition) {
            if (this._overlayRef) {
                this._overlayRef.removePanelClass('m-popover-position-' + this.popoverPosition);
                this._overlayRef.addPanelClass('m-popover-position-' + value);
                this._popoverPosition = value;
                this.updatePopoverPosition(this.popoverPosition);
                this._overlayRef.updatePosition();
            }
            else {
                this._popoverPosition = value;
            }
        }
    }
    /**
     * Disables the popover and the directive is locked.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.disabled) {
            this.hide();
        }
    }
    ngOnInit() {
        merge(fromEvent(this._elementRef.nativeElement, 'click'), fromEvent(this._elementRef.nativeElement, 'keydown').pipe(filter((event) => isValidOpenKeyCode(event))))
            .pipe(tap((event) => {
            event.stopPropagation();
            event.preventDefault();
        }), filter(() => !this.disabled), takeUntil(this._destroy$))
            .subscribe(() => {
            if (!this.isPopoverVisible) {
                this.show();
            }
            else {
                this.hide();
            }
        });
    }
    /**
     * Destroy life cycle to clean the _overlay from the DOM
     */
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
        if (this._overlayRef) {
            this._overlayRef.dispose();
        }
    }
    /**
     * Attaches the _overlay reference, sets the component visibility as false
     * and pass the parameters to the component
     */
    show() {
        if (this.canBeShowed()) {
            if (!this._overlayRef) {
                this.createOverlayPopover();
            }
            else {
                this.initializeOverlayEvents();
                this.updateClases();
            }
            const popoverPortal = new ComponentPortal(MPopoverComponent);
            this.popoverRef = this._overlayRef?.attach(popoverPortal);
            this.setPopoverContent();
            this.setPopoverElementRef();
            this.isPopoverVisible = true;
        }
    }
    initializeOverlayEvents() {
        if (this._overlayRef) {
            this._overlayRef
                .outsidePointerEvents()
                .pipe(takeUntil(this._overlayRef.detachments()))
                .subscribe(() => this.hide());
            this._overlayRef
                .keydownEvents()
                .pipe(filter((event) => event.code === 'Escape'))
                .pipe(takeUntil(this._overlayRef.detachments()))
                .subscribe(() => {
                this.hide();
                this._elementRef.nativeElement.focus();
            });
        }
    }
    /**
     * Detaches the _overlay reference and sets the component visibility as false
     */
    hide() {
        if (this.isPopoverVisible) {
            this._overlayRef?.detach();
            this.isPopoverVisible = false;
        }
    }
    /**
     * Creates the _overlay reference with the calculated position
     */
    createOverlayPopover() {
        const position = this.calculatePosition(this.popoverPosition);
        const positionStrategy = this._overlayPositionBuilder.flexibleConnectedTo(this._elementRef).withPositions(position);
        const scrollStrategy = this._overlay.scrollStrategies.reposition();
        this._overlayRef = this._overlay.create({
            positionStrategy,
            scrollStrategy
        });
        if (this.customPanelClass) {
            this._overlayRef.addPanelClass('m-popover-style-' + this.customPanelClass);
        }
        if (!this.hideTriangle) {
            this._overlayRef.addPanelClass('m-popover-position-' + this.popoverPosition);
        }
        this._overlayRef.addPanelClass('m-popover-panel');
        this.initializeOverlayEvents();
    }
    /**
     * Updates the position where the popover will appear
     *
     * @param popoverPosition MPopoverPosition
     */
    updatePopoverPosition(popoverPosition) {
        if (this._overlayRef) {
            const position = this._overlayRef.getConfig().positionStrategy;
            const updatedPosition = this.calculatePosition(popoverPosition);
            position.withPositions(updatedPosition);
        }
    }
    updateClases(newCustomClassValue) {
        if (this._overlayRef) {
            this._overlayRef.removePanelClass('m-popover-panel');
            this._overlayRef.removePanelClass('m-popover-style-' + this.customPanelClass);
            this._overlayRef.removePanelClass('m-popover-position-' + this.popoverPosition);
            if (this.customPanelClass) {
                this._overlayRef.addPanelClass('m-popover-style-' + (newCustomClassValue || this.customPanelClass));
            }
            if (!this.hideTriangle) {
                this._overlayRef.addPanelClass('m-popover-position-' + this.popoverPosition);
            }
            this._overlayRef.addPanelClass('m-popover-panel');
        }
    }
    /**
     * Calculates the position for the _overlay, taking into account the origin and _overlay coordinates for this one.
     *
     * @param popoverPosition Predefined positions allowed for popover
     * @returns An array with object that contains `originX`, `originY`, `overlayX`, `overlayY`, `offsetX` and `offsetY`
     */
    calculatePosition(popoverPosition) {
        const connectedPositions = {
            center: () => this._getCenterPosition(),
            top: () => this._getTopPosition(popoverPosition),
            bottom: () => this._getBottomPosition(popoverPosition),
            right: () => this._getRightPosition(popoverPosition),
            left: () => this._getLeftPosition(popoverPosition),
            custom: () => this._getCustomPosition()
        };
        const genericPosition = this._getGenericPosition(popoverPosition);
        if (genericPosition) {
            return connectedPositions[genericPosition]();
        }
        const position = connectedPositions[popoverPosition];
        return position ? position() : this._defaultConnectedPosition;
    }
    /**
     * If there is a popover reference pass the content argument
     */
    setPopoverContent() {
        if (this.popoverRef) {
            this.popoverRef.setInput('content', this.content);
        }
    }
    /**
     * If there is a popover reference pass the element ref argument
     */
    setPopoverElementRef() {
        if (this.popoverRef) {
            this.popoverRef.setInput('popoverElementRef', this._elementRef);
        }
    }
    _getGenericPosition(popoverPosition) {
        if (this._isTopPosition(popoverPosition)) {
            return 'top';
        }
        else if (this._isBottomPosition(popoverPosition)) {
            return 'bottom';
        }
        else if (this._isRightPosition(popoverPosition)) {
            return 'right';
        }
        else if (this._isLeftPosition(popoverPosition)) {
            return 'left';
        }
        return null;
    }
    _isTopPosition(popoverPosition) {
        return popoverPosition === 'top' || popoverPosition === 'topRight' || popoverPosition === 'topLeft';
    }
    _getCenterPosition() {
        return [
            {
                originX: 'center',
                originY: 'center',
                overlayX: 'center',
                overlayY: 'center'
            }
        ];
    }
    _getTopPosition(popoverPosition) {
        const overlayX = popoverPosition === 'topRight' ? 'start' : popoverPosition === 'topLeft' ? 'end' : 'center';
        return [
            {
                originX: 'center',
                originY: 'top',
                overlayX,
                overlayY: 'bottom',
                offsetY: -16
            }
        ];
    }
    _isBottomPosition(popoverPosition) {
        return popoverPosition === 'bottom' || popoverPosition === 'bottomRight' || popoverPosition === 'bottomLeft';
    }
    _getBottomPosition(popoverPosition) {
        const overlayX = popoverPosition === 'bottomRight' ? 'start' : popoverPosition === 'bottomLeft' ? 'end' : 'center';
        return [
            {
                originX: 'center',
                originY: 'bottom',
                overlayX,
                overlayY: 'top',
                offsetY: 16
            }
        ];
    }
    _isRightPosition(popoverPosition) {
        return popoverPosition === 'right' || popoverPosition === 'rightBottom' || popoverPosition === 'rightTop';
    }
    _getRightPosition(popoverPosition) {
        const overlayY = popoverPosition === 'rightBottom' ? 'top' : popoverPosition === 'rightTop' ? 'bottom' : 'center';
        return [
            {
                originX: 'end',
                originY: 'center',
                overlayX: 'start',
                overlayY,
                offsetX: 16
            }
        ];
    }
    _isLeftPosition(popoverPosition) {
        return popoverPosition === 'left' || popoverPosition === 'leftBottom' || popoverPosition === 'leftTop';
    }
    _getLeftPosition(popoverPosition) {
        const overlayY = popoverPosition === 'leftBottom' ? 'top' : popoverPosition === 'leftTop' ? 'bottom' : 'center';
        return [
            {
                originX: 'start',
                originY: 'center',
                overlayX: 'end',
                overlayY,
                offsetX: -16
            }
        ];
    }
    _getCustomPosition() {
        if (this.customConnectedPosition) {
            return [
                {
                    ...this._getCustomOrigins(this.customConnectedPosition),
                    ...this._getCustomOverlays(this.customConnectedPosition),
                    ...this._getCustomOffsets(this.customConnectedPosition)
                }
            ];
        }
        return this._defaultConnectedPosition;
    }
    _getCustomOrigins(customConnectedPosition) {
        return {
            originX: customConnectedPosition.originX || 'center',
            originY: customConnectedPosition.originY || 'top'
        };
    }
    _getCustomOverlays(customConnectedPosition) {
        return {
            overlayX: customConnectedPosition.overlayX || 'center',
            overlayY: customConnectedPosition.overlayY || 'bottom'
        };
    }
    _getCustomOffsets(customConnectedPosition) {
        return {
            offsetX: customConnectedPosition.offsetX || 0,
            offsetY: customConnectedPosition.offsetY || 0
        };
    }
    /**
     * Checks if popover is not disabled, it is not visible and it is connected to the element
     */
    canBeShowed() {
        return !this.disabled && !this.isPopoverVisible && this.isConnected();
    }
    /**
     * Checks if the element reference in the template is connected with the _overlay
     */
    isConnected() {
        return this._elementRef.nativeElement.isConnected;
    }
}
MPopoverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverDirective, deps: [{ token: i1$1.Overlay }, { token: i1$1.OverlayPositionBuilder }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
MPopoverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.9", type: MPopoverDirective, selector: "[m-popover]", inputs: { hideTriangle: "hideTriangle", customPanelClass: "customPanelClass", content: ["m-popover", "content"], popoverPosition: "popoverPosition", customConnectedPosition: ["popoverCustomPositionConfig", "customConnectedPosition"], disabled: ["popoverDisabled", "disabled"] }, host: { properties: { "class": "this.class" } }, exportAs: ["m-popover"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[m-popover]',
                    exportAs: 'm-popover'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Overlay }, { type: i1$1.OverlayPositionBuilder }, { type: i0.ElementRef }]; }, propDecorators: { hideTriangle: [{
                type: Input
            }], customPanelClass: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], content: [{
                type: Input,
                args: ['m-popover']
            }], popoverPosition: [{
                type: Input
            }], customConnectedPosition: [{
                type: Input,
                args: ['popoverCustomPositionConfig']
            }], disabled: [{
                type: Input,
                args: ['popoverDisabled']
            }] } });

class MPopoverModule {
}
MPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: MPopoverModule, declarations: [MPopoverComponent, MPopoverDirective], imports: [CommonModule, OverlayModule, A11yModule], exports: [MPopoverDirective] });
MPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverModule, imports: [CommonModule, OverlayModule, A11yModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MPopoverComponent, MPopoverDirective],
                    imports: [CommonModule, OverlayModule, A11yModule],
                    exports: [MPopoverDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { MPopoverDirective, MPopoverModule };
